import { useQuery } from '@tanstack/react-query'
import { IApiBaseTypes } from '@/types/query-api'
import { APIInstance } from '@/utils/functions/instance'
import { IContractsResponse } from './type'

export function useGetContracts({
  data,
  disableToast,
  ...rest
}: IApiBaseTypes<{}>) {
  return useQuery({
    queryFn: async () => {
      const response = await APIInstance<IContractsResponse>({
        url: 'mrf/contract/',
        params: data,
        method: 'get',
        data
      })
      return response
    },
    retry: 0,
    queryKey: ['address-item', data],
    select: (response) => response?.data,
    ...rest
  })
}
